// ...existing code...
import React, { useMemo } from 'react';
import { Select } from 'antd';
import dayjs from 'dayjs';
import calendar from '../../../../Assets/Icons/ExitInterview/calendar_month.svg'; // adjust path
import { InfoCircleOutlined } from '@ant-design/icons';
import SelectIconWrapperAntd from '../../../../Components/SelectIconWrapperAntd.js';

const OPTIONS = [
  { label: 'Last 90 Days', value: 'LAST_90_DAYS', months: 3 },
  { label: 'Last 6 Months', value: 'LAST_6_MONTHS', months: 6 },
  { label: 'Last 1 Year', value: 'LAST_1_YEAR', months: 12 },
];

export default function DateRangeFilter({ setFilters, defaultValue = 'LAST_90_DAYS', style = { width: 280 } }) {
  // Build options with an icon in front — this shows in dropdown AND in the selected value
  const options = useMemo(
    () =>
      OPTIONS.map(o => ({
        value: o.value,
        label: (
          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {/* <img src={calendar} alt="" style={{ width: 16, height: 16 }} /> */}
            {o.label}
          </span>
        ),
      })),
    [],
  );

  const handleFilter = (value) => {
    const now = dayjs();
    const opt = OPTIONS.find(o => o.value === value);
    const from = (opt?.days ? now.subtract(opt.days, 'day') : now.subtract(opt?.months || 0, 'month')).format('YYYY-MM-DD');
    const to = now.format('YYYY-MM-DD');

    setFilters?.(prev => ({ ...prev, dateRange: value, from, to }));
  };

  return (
    <SelectIconWrapperAntd
  startIcon={<img src={calendar} alt="" style={{ width: 16, height: 16, opacity: 0.8 }} />}
>
    <Select
      value={`Date Range: ${defaultValue}`}
      options={options}
      style={style}
      onChange={handleFilter}
      optionFilterProp="children"
      // showSearch
      // Placeholder also with leading icon
      placeholder={
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <img src={calendar} alt="" style={{ width: 16, height: 16, opacity: 0.7 }} />
          Select range
        </span>
      }
    />
    </SelectIconWrapperAntd>
  );
}
